import { INSPECAO_CASCO_LABELS, TIPO_MOBILIZACAO } from "../../../../../hooks/nova-obra.tipos";
import type { TipoRevisaoProps } from "./types-tipo-revisao";

export function useTipoRevisao({ tipo }: TipoRevisaoProps) {
  return {
    testIds: {
      tipo: `revisao-tipo-${tipo.codigo}`,
      semEscopo: `revisao-sem-escopo-${tipo.codigo}`,
    },
    mostraClienteContrato:
      tipo.codigo === TIPO_MOBILIZACAO || tipo.cliente.trim() !== "" || tipo.contrato.trim() !== "",
    inspecaoCascoRotulo:
      tipo.haveraInspecaoCasco && tipo.inspecaoCasco
        ? INSPECAO_CASCO_LABELS[tipo.inspecaoCasco]
        : null,
  };
}
